import Step from "@/model/progress/Step"
import StepId from "@/model/progress/StepId"

const applicantInfo = new Step({
    id: StepId.APPLICANT_INFO,
    title: "step.applicantInfo",
    isComplete: false,
})
const paymentOptions = new Step({
    id: StepId.PAYMENT_OPTIONS,
    title: "step.paymentOptions",
    isComplete: false,
})
const acceptOffer = new Step({
    id: StepId.ACCEPT_OFFER,
    title: "step.acceptOffer",
    isComplete: false,
})
const complete = new Step({
    id: StepId.COMPLETE,
    title: "step.complete",
    isComplete: false,
})

const StepsByMode = {
    full: [
        {...applicantInfo},
        {...acceptOffer},
        {...paymentOptions},
        {...complete}
    ],
    prequalify: [
        {...applicantInfo},
        {...paymentOptions},
        {...acceptOffer},
        {...complete}
    ],
    noOffer: [],
    null : []
}

export default StepsByMode
